// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Api from './plugins/api'
import UpdateValuesFromStore from './plugins/updateValuesFromStore'
import ElementUI from 'element-ui'
import lang from 'element-ui/lib/locale/lang/it'
import locale from 'element-ui/lib/locale'
import _ from 'lodash'

Vue.config.productionTip = false

_.noConflict()

Vue.use(ElementUI)
Vue.use(Api)
Vue.use(UpdateValuesFromStore)

locale.use(lang)

// filters
Vue.filter('capitalize', function (value) {
  if (value && value.toString) {
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  }
  return ''
})

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js